import {
  getFirestore,
  doc,
  setDoc,
  getDocs,
  query,
  where,
  collection,
  updateDoc,
  Timestamp,
} from "firebase/firestore";
import { db } from "../../firebase";
import Cookies from "js-cookie";

export const UpdateItemStatusqry = async (data) => {
  const guid = Cookies.get("guid") || "";
  if (!data?.description) {
    return { success: false, error: "Missing description" };
  }
  if (!data?.uid) {
    return { success: false, error: "Missing UID." };
  }
  if (!guid) {
    return { success: false, error: "Missing Not Login." };
  }
  const adminguid = Cookies.get("adminguid") || "";

  const ip = Cookies.get("ipaddress") || "";
  try {
  let indexstage = 1;
    const indexstageQuery = query(
      collection(db, "projectstaskitemstatus"),
      where("puid", "==", data.puid),
      where("itemuid", "==", data.itemuid), 
      where("adminguid", "==", adminguid),
    );
    const indexstageSnap = await getDocs(indexstageQuery);
    if (!indexstageSnap.empty) {
      indexstage = indexstageSnap.size + 1;
    }
    //
    const docRef = doc(db, "projectstaskitemstatus", data.uid);
    const timestamp = Timestamp.now();
    const savequery = {
      ...data,
      adminguid,
      ip,
      guid,
      indexstage,
      date_time: timestamp,
      login_name: Cookies.get("login_name") || "no",
      guid: Cookies.get("guid") || "",
      sessiontoken: Cookies.get("sessiontoken") || "logout",
      loginkey: Cookies.get("loginkey") || "",
      ip: Cookies.get("ipaddres") || "",
      device: navigator.userAgent || "",
      archived: false,
      save: false,
      favorite: false,
      status: true,
      latitude: Cookies.get("latitude") || "",
      longitude: Cookies.get("longitude") || "",  
      city: Cookies.get("city") || "",
      postcode: Cookies.get("postcode") || "",
      state: Cookies.get("state") || "",
      country: Cookies.get("country") || "",
    };

    await setDoc(docRef, savequery);
    //
     await updateDoc(doc(db, "projectstaskitem", data.itemuid), {
  status_complete: data.status_complete,
   itemstatus:data.itemstatus,
   itemstatuscolor:data.itemstatuscolor,
  update_date_time: timestamp,
});
    return { success: true };

  } catch (err) {
    console.error("Error creating task:", err);
    return { success: false, error: err.message || "Unknown error occurred" };
  }
};
